import React from "react";
import DatosDemograficos from '../../../containers/DatosDemograficos'
import { CAMPAIGN_2023 } from '../../../constants';

const EvacuadosPorProvincia = () => {
  return <DatosDemograficos campaign={CAMPAIGN_2023} year={2023}/>
};

export default EvacuadosPorProvincia;
